import Cookies from 'universal-cookie';

class StorageService {
  cookies = null;

  constructor() {
    this.cookies = new Cookies();
  }

  // https://www.chromestatus.com/feature/4506322921848832
  // https://tools.ietf.org/html/draft-ietf-httpbis-cookie-alone-01
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie#Directives
  _getKey = (key) => (window.location.protocol === 'https:' ? '__Secure-' + key : key);
  get = (key) => (this.cookies ? this.cookies.get(this._getKey(key)) : null);
  set = (key, value, options = {}) => {
    if (this.cookies) {
      const defaultOptions = {
        secure: window.location.protocol === 'https:',
        path: '/',
        maxAge: 7 * 24 * 60 * 60,
      };
      
      // If rememberMe is true, set cookie to expire in 30 days, otherwise session cookie
      if (options.rememberMe) {
        defaultOptions.maxAge = 30 * 24 * 60 * 60; // 30 days in seconds
      }
      
      this.cookies.set(this._getKey(key), value, { ...defaultOptions, ...options });
    }
  };

  remove = (key) => {
    if (this.cookies) {
      this.cookies.remove(this._getKey(key), {
        secure: window.location.protocol === 'https:',
        path: '/',
      });
    }
  };
}

const storageService = new StorageService();
export default storageService;
